/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Account from "../../assets/account-qrcode.svg";
import LogoBra from "../../assets/bradesco/logo-bradesco.svg";
import { CarouselPrimary } from "../../components/Carousel";
import { CardProductCart } from "../../components/CardProductCart";
import {
  CartContainer,
  CartContent,
  Products,
  TransactionComplete,
} from "./style";
import { fetchGetProofRequest } from "../../store/presentProof/getProofRequest/fetchCredential";
import { fetchCreateProofRequest } from "../../store/presentProof/createProofRequest/fetchCredential";
import { fetchCreateOOBInvitation } from "../../store/outOfBand/createOOBInvitation/fetchOOBInvitation";
import { successfulCheckoutCart } from "../../store/cart/cartSuccess";

export function ProductsCart() {
  const data = useSelector((state) => state.cartSlice.data);

  const totalCart = data.reduce((acc, product) => {
    return acc + product.price * product.quantity;
  }, 0);

  const product =
    process.env.REACT_APP_BRADESCO_ID === "true" ? "Bradesco iD" : "SOU iD";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userAgent = navigator.userAgent;
  const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);

  const proofStatus = useSelector((state) => state.GetProofRequest.data.state);
  const [shortenerUrl, setShortenerUrl] = useState(undefined);
  const [urlMobile, setUrlMobile] = useState(undefined);

  const presExId = useSelector(
    (state) => state.CreateProofRequest.data.presentation_exchange_id
  );

  const invitation = useSelector(
    (state) => state.CreateOOBInvitation.data.invitation_url
  );

  function getProofRequest() {
    dispatch(fetchGetProofRequest(presExId));

    if (proofStatus === "verified") {
      sessionStorage.setItem("session", "authenticated");
      dispatch(successfulCheckoutCart(true));
      navigate("/successful-purchase");
    }
  }

  function replaceUrlStart(url) {
    return url.replace(/^https/i, process.env.REACT_APP_IOS_APP);
  }

  async function postShortUrl(longUrl) {
    const data = await fetch(
      `https://blockchain.cpqd.com.br/hmcpqdid/oobMessage`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: `{
        "invite_url": "${longUrl}"    
      }`,
      }
    );
    const response = await data.text();
    setShortenerUrl(
      `https://blockchain.cpqd.com.br/hmcpqdid/oobMessage?id=${response}`
    );
    setUrlMobile(replaceUrlStart(invitation));
  }

  useEffect(() => {
    if (presExId === undefined) {
      dispatch(fetchCreateProofRequest());
    }
    dispatch(fetchCreateOOBInvitation(presExId));
  }, [presExId]);

  useEffect(() => {
    if (invitation !== undefined) {
      postShortUrl(invitation);
      const interval = setInterval(() => {
        getProofRequest();
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [invitation, proofStatus]);

  return (
    <CartContainer>
      <CartContent>
        <div className="contentItems">
          <h2 className="textTitle">Carrinho de compras</h2>
          <CardProductCart />
        </div>
        <TransactionComplete>
          {totalCart === 0 ? (
            <section className="orderClose">
              <p>
                Adicione a Televisão OLED ao carrinho para finalizar a compra.
              </p>
            </section>
          ) : (
            <>
              {process.env.REACT_APP_DEMO_TYPE === "full" ? (
                isMobile ? (
                  process.env.REACT_APP_BRADESCO_ID === "true" ||
                  process.env.REACT_APP_SOU_ID_ECOMMERCE === "true" ||
                  process.env.REACT_APP_ZKP === "true" ? (
                    <section className="btnDeepLink">
                      <a href={urlMobile} target="_blank" rel="noreferrer">
                        Fechar pedido com {product}
                      </a>
                      <p>
                        Exclusivo para pagamento com{" "}
                        <span>cartão de crédito</span>
                      </p>
                    </section>
                  ) : (
                    <section className="btnDeepLinkClearsale">
                      <h3>
                        Fechar pedido com <span>Confi ou SOU iD</span>
                      </h3>
                      <a href={urlMobile} target="_blank" rel="noreferrer">
                        Fechar com Confi ou SOU iD
                      </a>
                      <p>
                        Exclusivo para pagamento com{" "}
                        <span>cartão de crédito</span>
                      </p>
                    </section>
                  )
                ) : process.env.REACT_APP_BRADESCO_ID === "true" ||
                  process.env.REACT_APP_SOU_ID_ECOMMERCE === "true" ||
                  process.env.REACT_APP_ZKP === "true" ? (
                  <section className="infoComplete">
                    <div>
                      <h3>Fechar pedido com {product}</h3>
                      <img
                        src={
                          process.env.REACT_APP_BRADESCO_ID === "true"
                            ? LogoBra
                            : Account
                        }
                        alt=""
                      />
                    </div>
                    {shortenerUrl !== undefined ? (
                      <QRCodeSVG
                        size={280}
                        value={shortenerUrl}
                        className="qrcode"
                      />
                    ) : (
                      <div className="loader"></div>
                    )}
                    <p>
                      Exclusivo para pagamento com <br />{" "}
                      <span>cartão de crédito</span>
                    </p>
                  </section>
                ) : (
                  <section className="infoComplete">
                    <div>
                      <h3>
                        Fechar pedido com <span>Confi ou SOU iD</span>
                      </h3>
                    </div>
                    {shortenerUrl !== undefined ? (
                      <QRCodeSVG
                        size={280}
                        value={shortenerUrl}
                        className="qrcode"
                      />
                    ) : (
                      <div className="loader"></div>
                    )}
                    <p>
                      Exclusivo para pagamento com <br />{" "}
                      <span>cartão de crédito</span>
                    </p>
                  </section>
                )
              ) : null}
              {process.env.REACT_APP_ZKP === "true" ? null : (
                <section className="orderClose">
                  {process.env.REACT_APP_DEMO_TYPE !== "full" ? null : (
                    <p>Para outros métodos de pagamento:</p>
                  )}
                  <Link to="/checkout" className="orderCloseBtn">
                    Fechar pedido
                  </Link>
                </section>
              )}
            </>
          )}
        </TransactionComplete>
      </CartContent>
      <Products>
        <h2 className="textTitle">
          Também se interessam <span>Ver mais produtos</span>
        </h2>
        <CarouselPrimary />
      </Products>
    </CartContainer>
  );
}
